import React, { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Row, Col, message } from 'antd';
import Cookie from 'js-cookie';
import {
  SnippetsOutlined, HighlightOutlined,
  // ReadOutlined, SolutionOutlined, MessageOutlined,
  SettingOutlined, TeamOutlined
} from '@ant-design/icons';
import { getUserImg } from '../../common/utils';
// import { redirectUrl } from '../../service/request';
import './index.less';

interface IProps extends RouteComponentProps { };
interface IState {
  userinfo: any,
  userMenu: any[]
};
class UserInfo extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      userinfo: {}, // 用户信息
      userMenu: [
        {
          id: 1,
          name: '学习中心',
          menu: [
            {
              key: 'course',
              name: '课程中心',
              icon: <SnippetsOutlined />,
              url: '/college/menu/user/mycollect',
              isShow: true
            }, {
              key: 'test',
              name: '考试中心',
              icon: <HighlightOutlined />,
              url: '/college/menu/user/myexam',
              isShow: true
            }
            // {
            //   key: 'train',
            //   name: '培训通知',
            //   icon: <ReadOutlined />,
            //   url: '/college/menu/user/train',
            //   isShow: true
            // }, {
            //   key: 'project',
            //   name: '项目挑战',
            //   icon: <SolutionOutlined />,
            //   url: '/college/menu/user/project',
            //   isShow: true
            // }, {
            //   key: 'huati',
            //   name: '话题小组',
            //   icon: <MessageOutlined />,
            //   url: '/college/menu/user/message',
            //   isShow: true
            // }
          ]
        }, {
          id: 2,
          name: '管理中心',
          menu: [
            {
              key: 'user',
              name: '个人信息设置',
              icon: <SettingOutlined />,
              url: '/college/menu/user/basicinfo',
              isShow: true
            }, {
              key: 'manage',
              name: '管理后台',
              icon: <TeamOutlined />,
              url: '/admin/home',
              isShow: true
            }
          ]
        }
      ], // 菜单信息
    };
  }
  componentDidMount() {
    let { userMenu } = this.state;
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    // 后台管理权限
    userMenu[1].menu[1].isShow = userinfo.is_admin === 3 ? true : false;
    this.setState({
      userinfo,
      userMenu
    })
  }
  // 去往管理后台
  goLink(index1: number, index2: number) {
    const { userMenu } = this.state;
    let urlInfo = window.location.href;
    let _url: string = userMenu[index1].menu[index2].url;
    if (_url.indexOf('/admin') !== -1) {
      let _params = urlInfo.split('#');
      _url = `${_params[0]}#/admin/course/my`;
      localStorage.setItem('adminMenu', '/admin/course/my');
      window.open(_url, "_blank");
      // window.location.href = _url;
    } else {
      this.props.history.push(_url);
    }
  }
  clearAllCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if(keys) {
        for(var i = keys.length; i--;)
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
    document.cookie.split(';')
      .forEach(cookie => document.cookie = 
      cookie.replace(/^ +/, '')
      .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`));
  }
  // 退出
  logout = () => {
    message.success('退出账号成功');
    const _window: any = window;
    _window.userInfo = null;
    localStorage.clear();
    Cookie.remove('TOKEN:PARTNER:qingcloud', { path: '', domain: '.quanxiangyun.com' });
    document.cookie = "TOKEN:PARTNER:qingcloud=;  expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.quanxiangyun.com; path=/;";
    this.clearAllCookie();
    
    // window.location.href = window.location.origin + '/qingcloud/learning';
    window.location.href = window.location.origin + window.location.pathname;
    // axios({
    //   method: "POST",
    //   url: `${window.location.origin}/logout`,
    //   headers: {
    //     'x-tenant-domain': 'qingcloud'
    //   }
    // }).then((res: any) => {
    //   if (res && res.data && res.data.code === 200) {
    //     message.success('退出账号成功');
    //     const _window: any = window;
    //     _window.userInfo = null;
    //     localStorage.clear();
    //     // window.location.href = window.location.origin + '/qingcloud/learning';
    //     window.location.href = window.location.origin;
    //   } else {
    //     res && message.error('退出账号失败');
    //   }
    // })
  }
  render() {
    const { userinfo, userMenu } = this.state;
    const _info = getUserImg(userinfo.crm_account_name);
    return (
      <div className="user_info">
        <Row className="top" align="middle" justify="space-between">
          <Col>
            {/* <img className="userimg" src={User} alt="" /> */}
            <div className="userimg" style={{ background: `${_info.color}` }}>{_info.name}</div>
          </Col>
          <Col>
            <div className="topin">
              <div className="name">{userinfo.crm_account_name}</div>
              <div className="integral">积分： 暂无</div>
            </div>
          </Col>
          <Col>
            <div className="topin">
              {/* <div className="btn">讲师报名</div> */}
              <div className="btn out" onClick={this.logout}>安全退出</div>
            </div>
          </Col>
        </Row>
        <Row style={{ marginTop: 18 }}>
          <ul className="outul" >
            {
              userMenu.map((item1, index1) => {
                return (
                  <li key={item1.id}>
                    <div className="title">{item1.name}</div>
                    <ul className="inul">
                      {
                        item1.menu.map((item2: any, index2: number) => {
                          return (
                            item2.isShow ?
                              <li key={item2.key} onClick={() => this.goLink(index1, index2)}>
                                {item2.icon}
                                {item2.name}
                              </li>
                              : null
                          )
                        })
                      }
                    </ul>
                  </li>
                )
              })
            }
          </ul>
        </Row>
      </div>
    )
  }
}

export default withRouter(UserInfo);
